import { render } from "./manageOrgs.svg?vue&type=template&id=55f55c91"
const script = {}
script.render = render

export default script